import { call, put, takeLatest } from 'redux-saga/effects';
import { CorporateHealthOrderApi } from '@apis/CorporateHealthOrderApi';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { CorporateUser } from '@models/User';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';
import {
  corporateHealthOrdersFetch,
  corporateHealthOrderUsersFetch,
  CorporateHealthOrderUsersFetchPayload,
  corporateHealthOrderUserFetch,
  CorporateHealthOrderUserFetchPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handleCorporateHealthOrdersFetch() {
  const state: StateUpdatePayload = { corporateHealthOrders: null };
  try {
    state.corporateHealthOrders = (yield call(CorporateHealthOrderApi.getAll)) as CorporateHealthOrder[];
    yield put(stateUpdate(state));
  } catch { }
}

function* handleCorporateHealthOrderUsersFetch({ payload }: SagaPayload<CorporateHealthOrderUsersFetchPayload>) {
  const state: StateUpdatePayload = { corporateHealthOrderUsers: null, pagination: undefined };
  try {
    const [corporateUsers, pagination] = (yield call(CorporateHealthOrderApi.getUsers, payload)) as [CorporateUser[], Pagination];
    state.corporateHealthOrderUsers = corporateUsers;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCorporateHealthOrderUserFetch({ payload }: SagaPayload<CorporateHealthOrderUserFetchPayload>) {
  yield put(stateUpdate({ isLoading: true }));
  const state: StateUpdatePayload = { corporateHealthOrderUser: null };
  try {
    const corporateUser = (yield call(CorporateHealthOrderApi.findUser, payload)) as CorporateUser;
    state.corporateHealthOrderUser = corporateUser;
    yield put(stateUpdate({ ...state, isLoading: false }));
  } catch {
    yield put(stateUpdate({ ...state, isLoading: false }));
  }
}

export default function* () {
  yield takeLatest(corporateHealthOrdersFetch, handleCorporateHealthOrdersFetch);
  yield takeLatest(corporateHealthOrderUsersFetch, handleCorporateHealthOrderUsersFetch);
  yield takeLatest(corporateHealthOrderUserFetch, handleCorporateHealthOrderUserFetch);
}
